
<component
  :is="as"
  :class="['stat-item', size]"
  v-bind="$attrs"
  v-on="$listeners"
>
  <label>{{ label }}</label>

  <div class="value">
    <slot name="before" />
    <span v-show="!hasEmptyValue" :class="{ success, warning, error }">{{ displayValue }}</span>
    <slot name="after" />
  </div>
</component>
